/**
 * Rotulo de escopo para editores TR / CI / Notificação.
 * Deixa explícito se o editor atua no template global do fluxo/unidade ou em um processo.
 */
export function rotuloEscopoEditorDocumento({
  escopo,
  processoId = null,
  fluxoId = null,
  solicitacaoId = null,
} = {}) {
  if (solicitacaoId) {
    return `Escopo: solicitação #${solicitacaoId} (documento da solicitação).`;
  }
  if (escopo === 'processo' || processoId) {
    return `Escopo: processo #${processoId}${fluxoId ? ` · fluxo #${fluxoId}` : ''} (contexto do processo aberto).`;
  }
  if (fluxoId) {
    return `Escopo: template global do fluxo #${fluxoId} (aplica a todos os processos deste fluxo).`;
  }
  return 'Escopo: template global da unidade (não vinculado a um processo específico).';
}
